var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["name", "required", "pattern", "placeholder"];
var _hoisted_2 = ["name"];
import FormInput from "./FormInput.vue";
import AirDatepicker from "air-datepicker";
import 'air-datepicker/air-datepicker.css';
import { computed, onMounted, ref, useTemplateRef, watch } from "vue";
import { emulateReadonly, isMobile } from "../../utils";
import { formatISO9075 } from "date-fns";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Datepicker',
    props: /*@__PURE__*/ _mergeModels({
        label: String,
        name: { type: String, default: 'delivery_date' },
        required: Boolean,
        error: String,
        // datepicker config:
        minDate: Date,
        maxDate: Date,
        timepicker: Boolean,
        holidays: { type: Array, default: [] },
        disabledDays: { type: Array, default: [] },
        config: { type: Object, default: {} },
    }, {
        "modelValue": {},
        "modelModifiers": {},
        "date": {},
        "dateModifiers": {},
        "dateFormatted": {},
        "dateFormattedModifiers": {},
    }),
    emits: ["update:modelValue", "update:date", "update:dateFormatted"],
    setup: function (__props) {
        var props = __props;
        var input = useTemplateRef('input');
        var value = _useModel(__props, "modelValue");
        var dateModel = _useModel(__props, 'date');
        var dateFormatted = _useModel(__props, 'dateFormatted');
        var datepickerInstance = ref();
        var pattern = computed(function () { return "\\d\\d?\\.\\d\\d?\\.\\d{4}".concat(props.timepicker ? ' ([01]?\\d|2[0-3]):([0-5]?\\d)' : ''); });
        var placeholder = computed(function () { return "\u0434\u0434.\u043C\u043C.\u0433\u0433\u0433\u0433".concat(props.timepicker ? ' чч:мм' : ''); });
        watch(function () { return [props.minDate, props.maxDate, props.disabledDays, props.holidays]; }, function () {
            if (datepickerInstance.value) {
                datepickerInstance.value.destroy();
            }
            initDatepicker(props.minDate, props.maxDate, props.disabledDays, props.holidays, props.config);
        });
        onMounted(function () {
            var startDate = new Date();
            startDate.setHours(startDate.getHours() + (startDate.getHours() >= 22 ? 10 : 1), 0, 0);
            initDatepicker(props.minDate, props.maxDate, props.disabledDays, props.holidays, props.config);
        });
        function initDatepicker(minDate, maxDate, disabledDays, _holidays, config) {
            if (datepickerInstance.value) {
                datepickerInstance.value.destroy();
            }
            datepickerInstance.value = new AirDatepicker(input.value, __assign({ minDate: minDate, maxDate: maxDate, autoClose: true, dateFormat: 'dd.MM.yyyy', position: 'top left', toggleSelected: false, isMobile: isMobile, timepicker: props.timepicker, onRenderCell: function (_a) {
                    var date = _a.date, cellType = _a.cellType;
                    if (cellType === 'day') {
                        var dateFormatted_1 = dateOnly(date);
                        return {
                            disabled: disabledDays.includes(dateFormatted_1),
                        };
                    }
                }, onSelect: function (_a) {
                    var date = _a.date, formattedDate = _a.formattedDate;
                    if (Array.isArray(date) || Array.isArray(formattedDate)) {
                        return;
                    }
                    value.value = formattedDate;
                    dateModel.value = date;
                    dateFormatted.value = formatDate(date);
                } }, config));
            validateDate(minDate, maxDate, disabledDays);
            emulateReadonly(input.value);
        }
        function validateDate(minDate, maxDate, disabledDays) {
            if (value.value !== '' && value.value !== undefined) {
                try {
                    var date = makeDate(value.value);
                    var dateFormatted_2 = formatDate(date);
                    var minDateFormatted = formatDate(minDate);
                    var maxDateFormatted = formatDate(maxDate);
                    if (dateFormatted_2 >= minDateFormatted && dateFormatted_2 <= maxDateFormatted && !disabledDays.includes(dateOnly(date))) {
                        datepickerInstance.value.selectDate(date);
                    }
                    else {
                        datepickerInstance.value.unselectDate(date);
                        value.value = '';
                    }
                }
                catch (e) {
                    value.value = '';
                }
            }
        }
        function dateOnly(date) {
            return formatISO9075(date, { representation: "date" });
        }
        function formatDate(date) {
            if (props.timepicker) {
                return date.toISOString();
            }
            return dateOnly(date);
        }
        function makeDate(dateString) {
            dateString = dateString.replace(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/, '$3-$2-$1');
            return new Date(dateString);
        }
        watch(value, function () { return validateDate(props.minDate, props.maxDate, props.disabledDays); });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(FormInput, {
                name: "delivery_date",
                label: __props.label,
                error: __props.error,
                required: __props.required,
                modelValue: value.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((value).value = $event); })
            }, {
                default: _withCtx(function () { return [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: __props.name,
                        class: "form-control",
                        autocomplete: "off",
                        required: __props.required,
                        pattern: pattern.value,
                        placeholder: placeholder.value,
                        id: "card_delivery_date",
                        ref_key: "input",
                        ref: input,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((value).value = $event); })
                    }, null, 8 /* PROPS */, _hoisted_1), [
                        [_vModelText, value.value]
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _withDirectives(_createElementVNode("input", {
                        type: "hidden",
                        name: "".concat(__props.name, "_formatted"),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((dateFormatted).value = $event); })
                    }, null, 8 /* PROPS */, _hoisted_2), [
                        [_vModelText, dateFormatted.value]
                    ])
                ]; }),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label", "error", "required", "modelValue"]));
        };
    }
});
